export default __webpack_public_path__ + "static/media/img8.f17c6ce3.jpg";